const TEXT = {
  LOGIN: {id: 'navigation.menu.question.text'},
  LOGIN_CTA: {id: 'navigation.menu.question.cta'},
  QUIZ_CTA: {id: 'navigation.start.cta'},
};

export {TEXT};
